import React from "react";
import {useIntl} from "react-intl";
import Seo from "./seo";

const GetizySeo = () => {
    const intl = useIntl();
    return <Seo title={intl.formatMessage({id: 'seo'})}/>
}

export default GetizySeo;